(function(){
  // ============ 1. Hebrew title fix for /collections/all ============
  function fixCollectionTitle(){
    try {
      var path = window.location.pathname;
      if (path === '/collections/all' || path === '/collections/all/' || path.indexOf('/collections/all?') === 0) {
        var h1s = document.querySelectorAll('main h1');
        for (var i = 0; i < h1s.length; i++){
          var txt = (h1s[i].textContent || '').trim();
          if (txt === 'Products' || txt === 'products' || txt === 'PRODUCTS') {
            h1s[i].textContent = 'כל המוצרים';
          }
        }
      }
    } catch(e) {}
  }

  // ============ 2. Auto-tag sections for scroll reveal ============
  function autoTag(){
    try {
      // Auto-tag every non-first section in main for fade-up reveal
      var sections = document.querySelectorAll('main > .shopify-section');
      for (var i = 1; i < sections.length; i++){
        if (!sections[i].hasAttribute('data-reveal') && !sections[i].hasAttribute('data-reveal-skip')) {
          sections[i].setAttribute('data-reveal', '');
        }
      }
      // Tag product grids and product card containers for stagger reveal
      var grids = document.querySelectorAll('.product-grid, .product-list, product-list-section, [class*="product-grid"], [class*="product-list__"], main-collection .product-grid, ul.product-grid, ol.product-grid');
      grids.forEach(function(g){
        if (!g.hasAttribute('data-reveal-products')) g.setAttribute('data-reveal-products', '');
      });
      // Also tag .hd-bento for stagger reveal
      var bento = document.querySelectorAll('.hd-bento-v2, .hd-bento, .hd-stats');
      bento.forEach(function(b){
        if (!b.hasAttribute('data-reveal-stagger')) b.setAttribute('data-reveal-stagger', '');
      });
    } catch(e) {}
  }

  // ============ 3. IntersectionObserver setup ============
  if (typeof IntersectionObserver === 'undefined') {
    document.addEventListener('DOMContentLoaded', function(){
      fixCollectionTitle();
      document.querySelectorAll('[data-reveal], [data-reveal-stagger], [data-reveal-products]').forEach(function(el){ el.classList.add('is-revealed'); });
    });
    return;
  }
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    document.addEventListener('DOMContentLoaded', function(){
      fixCollectionTitle();
      autoTag();
      document.querySelectorAll('[data-reveal], [data-reveal-stagger], [data-reveal-products]').forEach(function(el){ el.classList.add('is-revealed'); });
    });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

  function observe(){
    document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-reveal-stagger]:not(.is-revealed), [data-reveal-products]:not(.is-revealed)').forEach(function(el){
      io.observe(el);
    });
  }

  function init(){
    fixCollectionTitle();
    autoTag();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when new content is added (filters, pagination, etc.)
  var mo = new MutationObserver(function(){
    fixCollectionTitle();
    autoTag();
    observe();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Safety net: after 4s reveal any visible elements that didn't trigger
  setTimeout(function(){
    document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-reveal-stagger]:not(.is-revealed), [data-reveal-products]:not(.is-revealed)').forEach(function(el){
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 100) el.classList.add('is-revealed');
    });
  }, 4000);
})();
